/**
 * Зеркало серверного реестра адресов картинок блоков
 * (`backend/src/ai-funnels/block-schema/image-url-fields.ts`,
 * `IMAGE_URL_FIELDS` и узел-картинка `{kind:'image', url}`). Импорт сервера в
 * кабинет недоступен, поэтому список повторён здесь, а совпадение в обе
 * стороны держит серверный сторож
 * `image-url-fields.frontend-mirror.spec.ts` (свежий взгляд сведения
 * стильпаков, WEB-3718). Читатель — предзагрузка следующего экрана
 * (`components/quiz-runtime/nextScreenImageCandidates.ts`).
 */
export const IMAGE_URL_FIELDS: readonly string[] = [
  'imageUrl',
  'beforeImageUrl',
  'afterImageUrl',
  'cardImageUrl',
  'preferenceImageUrl',
  'scratchCoverImageUrl',
  'blurTeaserLockIconUrl',
  'iconUrl',
  'leadingIconUrl',
  'sideImageUrl',
  'photoUrl',
];

/** Узел-картинка: значок варианта `{kind:'image', url}` (option-grid). */
export const IMAGE_NODE_KIND = 'image';
export const IMAGE_NODE_URL_KEY = 'url';

/** Лежит ли под ключом узла адрес картинки — та же дверь, что у сервера. */
export function isImageUrlKeyOf(
  node: Record<string, unknown>,
  key: string,
): boolean {
  if (IMAGE_URL_FIELDS.includes(key)) return true;
  return key === IMAGE_NODE_URL_KEY && node.kind === IMAGE_NODE_KIND;
}
